import Vue from 'vue';
import App from './app';
import VueWait from 'vue-wait';
import VuexRouterSync from 'vuex-router-sync';

import '@src/plugins/axios';
import '@src/plugins/vue-toasted';
import '@src/plugins/vee-validate';
import '@src/plugins/vue-progress';
import { i18n } from '@src/plugins/vue-i18n';
import '@src/plugins/vue-bootstrap';
import '@src/plugins/vue-font-awesome';
import '@src/plugins/vuejs-dialog';

import router from '@router';
import store from '@state/store';
import '@components/_globals';

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

// If running inside Cypress...
if (window.Cypress) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException;
}

Vue.use(VueWait);
VuexRouterSync.sync(store, router);

const app = new Vue({
  router,
  store,
  i18n,
  wait: new VueWait({
    useVuex: true,
  }),
  render: (h) => h(App),
}).$mount('#app');

// If running inside Cypress...
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app;
}

// flatpicker diry fix
function getParents(el, parentSelector /* optional */) {

  // If no parentSelector defined will bubble up all the way to *document*
  if (parentSelector === undefined) {
    parentSelector = document;
  }

  var parents = [];
  var p = el.parentNode;

  while (p !== parentSelector) {
    var o = p;
    parents.push(o);
    p = o.parentNode;
  }
  parents.push(parentSelector); // Push that parentSelector you wanted to stop at

  return parents;
}

window.addEventListener('touchstart', function(e) {
  let parents = getParents(e, document.getElementsByClassName('.flatpickr-calendar'));
  if (parents.length === 0 && e.target !== document.body)
    document.body.click();
});
